export default import.meta.ROLLDOWN_FILE_URL_3jJcHWTdo$1m7MCPQMnJBw